import React from 'react';

import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

const PaperPlaneIcon = ({ size = IconSize[24] }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 16 16"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.36 1.54961C14.0373 1.31295 14.688 1.96361 14.4513 2.64095L10.5013 13.9276C10.2447 14.6596 9.22465 14.7009 8.90998 13.9923L7.00398 9.70428L9.68665 7.02095C9.77497 6.92616 9.82305 6.8008 9.82077 6.67126C9.81848 6.54173 9.76601 6.41814 9.6744 6.32653C9.58279 6.23492 9.4592 6.18245 9.32967 6.18016C9.20013 6.17788 9.07477 6.22596 8.97999 6.31428L6.29665 8.99695L2.00865 7.09095C1.29998 6.77561 1.34198 5.75628 2.07332 5.49961L13.36 1.54961Z"
      fill="currentColor"
    />
  </svg>
);

PaperPlaneIcon.propTypes = {
  size: PropTypes.number,
};

export default PaperPlaneIcon;
